import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LogoCarousel = () => {
  const { t } = useLanguage();

  const clients = [
    { name: 'Bemis', logo: '/images/clients/bemis.png' },
    { name: 'Grupo Midiograf', logo: '/images/clients/midiograf.png' },
    { name: 'Dentalclean', logo: '/images/clients/dentalclean.png' },
    { name: 'Indusbello Co.', logo: '/images/clients/indusbello.png' },
    { name: 'Dixie Toga', logo: '/images/clients/dixietoga.png' },
    { name: 'Alumínios Cambé', logo: '/images/clients/cambe.png' },
    { name: 'Metalrevest', logo: '/images/clients/metalrevest.png' },
    { name: 'Gulosina Alimentos', logo: '/images/clients/gulosina.png' },
    { name: 'Amcor', logo: '/images/clients/amcor.png' }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-slate-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Título */}
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold mb-3" style={{ color: '#193B7F' }}>
            {t.clients?.title || 'Empresas que Confiam na SMARTIN'}
          </h2>
          <p className="text-gray-600">
            {t.clients?.subtitle || 'Parceiros de sucesso em transformação empresarial'}
          </p>
        </div>

        {/* Carrossel de Logos */}
        <div className="relative">
          {/* Fade nas bordas */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-slate-50 to-transparent z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-slate-50 to-transparent z-10"></div>

          {/* Container do carrossel */}
          <div className="logo-carousel-container">
            <div className="logo-carousel-track">
              {/* Primeira sequência de logos */}
              {clients.map((client, index) => (
                <div key={`logo-1-${index}`} className="logo-carousel-item">
                  <img
                    src={client.logo}
                    alt={client.name}
                    className="logo-image"
                  />
                </div>
              ))}
              {/* Segunda sequência (duplicada para loop infinito) */}
              {clients.map((client, index) => (
                <div key={`logo-2-${index}`} className="logo-carousel-item">
                  <img
                    src={client.logo}
                    alt={client.name}
                    className="logo-image"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .logo-carousel-container {
          width: 100%;
          overflow: hidden;
        }

        .logo-carousel-track {
          display: flex;
          animation: scroll 40s linear infinite;
          width: fit-content;
        }

        .logo-carousel-item {
          flex-shrink: 0;
          width: 220px;
          height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 40px;
          padding: 15px;
          background: white;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
        }

        .logo-carousel-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
        }

        .logo-image {
          width: 100%;
          height: 100%;
          max-width: 100%;
          max-height: 90px;
          object-fit: contain;
          filter: grayscale(0%);
          opacity: 1;
          transition: all 0.3s ease;
        }

        .logo-carousel-item:hover .logo-image {
          transform: scale(1.05);
        }

        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        /* Pausa a animação ao passar o mouse */
        .logo-carousel-container:hover .logo-carousel-track {
          animation-play-state: paused;
        }

        /* Responsivo */
        @media (max-width: 768px) {
          .logo-carousel-item {
            width: 180px;
            height: 100px;
            margin: 0 20px;
            padding: 12px;
          }

          .logo-image {
            max-height: 70px;
          }

          .logo-carousel-track {
            animation: scroll 30s linear infinite;
          }
        }
      `}</style>
    </section>
  );
};

export default LogoCarousel;
